const TranslationLoader = async (code_Country = navigator.language, fallback = 'en-US') => {
  try {
    const definitions = await import(`../translations/${code_Country}.js`)
    return definitions.default ? definitions.default : definitions
  } catch (e) {
    const definitions = await import(`../translations/${fallback}.js`)
    return definitions.default ? definitions.default : definitions
  }
}

export default TranslationLoader
